// extracted by mini-css-extract-plugin
module.exports = {"p":"Footer-module--p--24sjS","footer":"Footer-module--footer--24vd3"};